// src/pages/QuienesSomosPage.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { FiTarget, FiEye, FiZap, FiDollarSign, FiHome } from 'react-icons/fi';
import styles from './QuienesSomosPage.module.css'; 

const QuienesSomosPage: React.FC = () => {
    return (
        <div className={styles.container}>
            
            <div style={{ marginBottom: '30px' }}>
                <Link to="/" style={{ 
                    color: 'var(--color-primario)', 
                    textDecoration: 'none', 
                    fontWeight: 600, 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px' 
                }}>
                    <FiHome /> Volver al Inicio
                </Link>
            </div>
            
            <header className={styles.header}>
                <h1 className={styles.title}>Misión, Visión y Objetivos</h1>
                <p className={styles.subtitle}>Conoce los fundamentos de Profunding.</p>
            </header>

            <section className={styles.sectionCard}>
                <div className={styles.iconWrapper}><FiTarget /></div>
                <h2 className={styles.sectionTitle}>Misión</h2>
                <p className={styles.sectionText}>
                    Apoyar al mercado inmobiliario con inversión de un gran número de micro inversionistas a través de la tecnología digital, para que, de una manera sencilla, ágil y rápida, puedan acceder a inversiones, con respaldo inmobiliario y rendimientos atractivos que individualmente no podrían tener acceso.
                </p>
            </section>

            <section className={styles.sectionCard} style={{backgroundColor: '#f9f5ff'}}>
                <div className={styles.iconWrapper}><FiEye /></div>
                <h2 className={styles.sectionTitle}>Visión</h2>
                <p className={styles.sectionText}>
                    Ser la empresa Fintech líder en el mercado nacional, con Clientes (Inversionistas y Solicitantes) satisfechos por ver crecer su patrimonio a través de inversiones profesionales respaldadas con la experiencia de sus directivos y el acceso a inmuebles que cumplan la premisa de inversión, con un crecimiento exponencial en cuanto a nuestros usuarios registrados en la plataforma tecnológica Profunding.
                </p>
            </section>
            
            <section className={styles.sectionCard}>
                <div className={styles.iconWrapper}><FiZap /></div>
                <h2 className={styles.sectionTitle}>Objetivos Principales</h2>
                <ul className={styles.objectivesList}>
                    <li>
                        <FiDollarSign className={styles.objectiveIcon} /> 
                        Ofrecer las mejores opciones en inversiones inmobiliarias a través de una IFC basada en regalías al alcance de los mexicanos, uniendo la agilidad de lo digital con la confianza y experiencia del factor humano.
                    </li>
                </ul>
            </section>
            
            <div style={{ textAlign: 'center', marginTop: '40px', padding: '20px 0', borderTop: '1px solid #f0f0f0' }}>
                <Link to="/" style={{ 
                    color: 'var(--color-primario)', 
                    textDecoration: 'none', 
                    fontWeight: 600, 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    fontSize: '1.1rem'
                }}>
                    <FiHome /> Explorar el Home de Profunding
                </Link>
            </div>

        </div>
    );
};

export default QuienesSomosPage;